export default function Error(){
    return <>
       <div className="error404 d-flex flex-wrap justify-content-center align-items-center"  >
       <div class="fof">
        		<h1>404</h1>
                <p>Page not found !!</p>
    	</div>
    </div>
    </>
}